import config from '../config';

/** GET `path` and parse JSON, throwing the API's error message on failure. */
export async function getJson<T>(path: string): Promise<T> {
  const res = await fetch(`${config.apiUrl}${path}`);
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error?.message ?? 'Request failed');
  return data as T;
}

/** POST `body` as JSON to `path` and parse the JSON response. */
export async function postJson<T>(path: string, body: unknown): Promise<T> {
  const res = await fetch(`${config.apiUrl}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.error?.message ?? 'Request failed');
  return data as T;
}
